import React from 'react';
import Page from "../../components/Page";
import Progress from '../../components/Progress';
import Collapsible from '../../components/Collapsible';
import { ReactComponent as GearIcon } from '../../assets/images/settings-gear.svg';
import { Link } from 'react-router-dom';
import { useMember } from './MemberContext';
import ErrorPage from '../ErrorPage';

const Requirement = ({ title, description, progress }) => {
    return (
        <div className='requirement'>
            <div className='requirement-title-and-percent'>
                <h3>{title}</h3>
                <span className='requirement-description-mobile'>{description}</span>
                <span className="progress-label">{progress}% Complete</span>
            </div>
            <Progress now={progress} label={`${progress}%`} requirement={description} />
        </div>
    );
};

const SwagChecklist = ({ activeSemesters, swagItems }) => {
    return (
        <div>
            {swagItems.map((item) => (
                <div key={item.id} className="swag-item">
                    <input
                        type="checkbox"
                        checked={activeSemesters >= parseInt(item.activeSemestersRequired)} // Check if activeSemesters meets or exceeds the current semester value
                        readOnly
                    />
                    {item.activeSemestersRequired > 8 ? <label style={{ paddingLeft: '2%' }}>{item.rewardName} (Graduating)</label> : <label style={{ paddingLeft: '2%' }}>{item.rewardName} ({item.activeSemestersRequired} semesters)</label>}
                </div>
            ))}
        </div>
    );
};

const getNextSwag = (activeSemesters, swagItems) => {
    if (swagItems.length > 0) {
        const nextMilestone = (Math.floor(activeSemesters / 2) + 1) * 2;
        const nextItem = swagItems.find((item) => item.activeSemestersRequired === nextMilestone);
        return nextItem?.rewardName;
    }
    return "No Swag Available";
};

const MemberDashboard = () => {
    const { roles, member, activeSemesters, memberIsActive, activeMemberRules, swagItems, apiSuccess } = useMember();

    const correctRolesForLink = ["ADMIN", "CHEAD", "LOGHEAD"].some(r => roles.includes(r));

    const nextSwag = getNextSwag(activeSemesters, swagItems);

    const completedCount = swagItems.filter(item =>
        activeSemesters >= Number(item.activeSemestersRequired)
    ).length;

    const userDisplayName = member?.preferredName || member?.firstName;

    // TODO: API Success
    return (
        <>
        {!apiSuccess && <ErrorPage />}
        {apiSuccess && (
            <Page>
                <div className="member-dashboard-heading" style={{ textAlign: 'right', display: 'flex', padding: '2%', flexWrap: 'wrap'}}>
                    <h1 className='member-dashboard-title' >Membership Dashboard</h1>
                    <div>
                        <h5>{userDisplayName ? `Hello, ${userDisplayName}` : 'Hello'}</h5>
                        <Link to="/member/settings">
                            <GearIcon width={40} height={40} fill='#4D1F5B' style={{ cursor: 'pointer', marginLeft: '1em' }} />
                        </Link>
                    </div>
                </div>
                {(correctRolesForLink) && (
                    <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '2%', paddingBottom: '2%' }}>
                        <Link to={"/admin/members"}>Admin Page</Link>
                    </div>
                )}

                    <div className="member-dashboard">
                        <div className="main-container">

                            <div className="sidebar">
                                <div className="fixed-section">
                                    <h2>Membership Requirements</h2>
                                    <div className='member-heading' style={{ marginBottom: '10%' }}>
                                        <div className='status'>
                                            <p className="active-status" style={{ fontSize: '1.1em' }}>
                                                <strong>Status:</strong> <span className={memberIsActive ? "text-green" : "text-red"}>{memberIsActive ? "Active" : "Inactive"}</span>
                                            </p>
                                        </div>
                                        <p style={{ fontSize: '1.1em' }}><strong>Active Semesters:</strong> {activeSemesters}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="swag-options">
                                <Collapsible title={<span><strong style={{ fontSize: '1.1em' }}>Next Swag Item:</strong><br></br> {nextSwag} ({completedCount} of {Object.keys(swagItems).length})</span>}>
                                    <SwagChecklist activeSemesters={activeSemesters} swagItems={swagItems} />
                                </Collapsible>
                            </div>
                        </div>

                        <div className={'requirements'}>
                            {activeMemberRules.map((activeMemberRule, i) => {
                                const { rule, progress } = activeMemberRule;
                                return (
                                    <Requirement
                                        key={i}
                                        title={rule.title}
                                        description={rule.description}
                                        progress={progress}
                                    />
                                );
                            })}
                        </div>
                    </div>
                </Page>
            )}
        </>
    );
};

export default MemberDashboard;
